import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, CollapseCard, FieldLabel, FlexBox, Spinner, Text, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { FieldTemplate } from 'components/fieldTemplate';
import { useBreakpointValue } from 'utils/mediaQuery';
import { editorMaxLines } from '../../../configuration';
import styles from './cardsTestResult.module.scss';
import { TestContent } from './components/testContent/testContent';
export const CardsTestResult = ({ card, isLoading, testResult, hasFailed, scrollRef, }) => {
    var _a;
    const isMediumScreen = useBreakpointValue({ base: true, lg: false });
    const [isCollapsed, setIsCollapsed] = useState(true);
    if (isLoading) {
        return _jsx(Spinner, { "data-testid": "loadingTestResultId" });
    }
    if (!card || !testResult) {
        return null;
    }
    const isCustomCard = 'request' in card;
    const title = isCustomCard
        ? card.title
        : card.hook.title;
    const createdAt = isCustomCard
        ? card.created_at
        : card.hook.created_at;
    const cardVersion = isCustomCard
        ? card.card_version
        : card.hook.card_version;
    const resultContent = (_a = testResult === null || testResult === void 0 ? void 0 : testResult.result) === null || _a === void 0 ? void 0 : _a.contents;
    const rawJSON = testResult === null || testResult === void 0 ? void 0 : testResult.raw_json;
    return (_jsxs("div", Object.assign({ ref: scrollRef, "data-testid": "testResultId" }, { children: [_jsx(Text.Heading, Object.assign({ className: styles.testResult }, { children: "Test result" })), _jsxs(FlexBox, Object.assign({ gap: isMediumScreen ? '250' : '400', flexDirection: isMediumScreen ? 'column' : 'row', margin: "0 0 400 0" }, { children: [_jsx(FieldTemplate, { readOnly: true, label: "JSON response", editorOptions: { minLines: 1, maxLines: editorMaxLines }, input: {
                            value: JSON.stringify(rawJSON ? JSON.parse(rawJSON) : testResult, null, 2),
                        }, meta: {
                            warning: !resultContent
                                ? 'The render response is empty'
                                : undefined,
                            error: hasFailed
                                ? 'Call to retrieve the rendered test failed'
                                : undefined,
                        } }), !isMediumScreen && _jsx(FlexBox, { className: styles.testResultDivider }), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: [_jsx(FieldLabel, { children: "Rendered response" }), _jsxs(CollapseCard, Object.assign({ onToggle: () => setIsCollapsed(!isCollapsed), isOpen: isCollapsed, className: styles.testResultCollapse }, { children: [_jsx(CollapseCard.Header, Object.assign({ avatar: _jsx(Avatar, { icon: "circle-filled" }), className: styles.testResultCollapseHeader }, { children: title })), _jsx(CollapseCard.Content, { children: _jsx(CollapseCard.Line, Object.assign({ label: "" }, { children: resultContent && (_jsx(TestContent, { content: resultContent, createdAt: createdAt, cardVersion: cardVersion })) })) })] }))] }))] }))] })));
};
